if (!customElements.get('logo-carousel')) {
  customElements.define(
    'logo-carousel',
    class LogoCarousel extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperLoadAttempts = 0;
        this.initTimeout = null;
      }

      connectedCallback() {
        this.carousel = this.querySelector('[data-logo-carousel]');
        this.initSwiper();
      }

      disconnectedCallback() {
        window.clearTimeout(this.initTimeout);
        this.destroySwiper();
      }

      destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      parseSlides(value, fallback) {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      }

      initSwiper() {
        if (!this.carousel || this.swiper) return;

        const slides = this.carousel.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        if (typeof window.Swiper !== 'function') {
          if (this.swiperLoadAttempts < 40) {
            this.swiperLoadAttempts += 1;
            this.initTimeout = window.setTimeout(() => this.initSwiper(), 50);
          }
          return;
        }

        const desktopSlides = this.parseSlides(this.dataset.slidesDesktop, 6);
        const tabletSlides = this.parseSlides(this.dataset.slidesTablet, 4);
        const mobileSlides = this.parseSlides(this.dataset.slidesMobile, 2);
        const autoplayEnabled = this.dataset.autoplay === 'true';
        const autoplaySpeed = this.parseSlides(this.dataset.autoplaySpeed, 4);
        const prevEl = this.querySelector('[data-logo-carousel-prev]');
        const nextEl = this.querySelector('[data-logo-carousel-next]');
        const paginationEl = this.querySelector('[data-logo-carousel-pagination]');
        const canLoop = slides.length > Math.max(desktopSlides, tabletSlides, mobileSlides);

        this.swiper = new window.Swiper(this.carousel, {
          slidesPerView: mobileSlides,
          spaceBetween: 24,
          loop: canLoop,
          watchOverflow: true,
          grabCursor: true,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          autoplay:
            autoplayEnabled && slides.length > 1
              ? {
                  delay: autoplaySpeed * 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
          breakpoints: {
            769: {
              slidesPerView: tabletSlides,
              spaceBetween: 32,
            },
            990: {
              slidesPerView: desktopSlides,
              spaceBetween: 40,
            },
          },
        });
      }
    }
  );
}
